import { render, staticRenderFns } from "./DocumentJurisdiction.vue?vue&type=template&id=7e73cef8&scoped=true"
import script from "./DocumentJurisdiction.vue?vue&type=script&lang=js"
export * from "./DocumentJurisdiction.vue?vue&type=script&lang=js"
import style0 from "./DocumentJurisdiction.vue?vue&type=style&index=0&id=7e73cef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e73cef8",
  null
  
)

export default component.exports